import Common from "../../Common";

export interface CompanyPstnNumber {
	nummer: string
	e164: number
	adress_id: null | id
	nummer_added: string
	NummerUpplysning: 0 | 1 | "0" | "1"
	NummerUpplysningShowUser: 0 | 1 | "0" | "1"
	KundPersonID: 0 | 1 | "0" | "1"
	status: 0 | 1 | "0" | "1"
	SmsFixed2CellE164: null | string
	operator: string
	type: string
	callforward_congestion: string
	callforward_always: string
	callforward_always_use_bnr: 0 | 1 | "0" | "1"
	callforward_busy: string
	callforward_noanswer: string
	callforward_noanswer_time: null | string
	closed: null | string
	trunk_name: string
}

const PstnNumber = class extends Common {
	browse = (companyId: id): CustomResponse<{ numbers: { [number: string]: CompanyPstnNumber }}> =>
		this.get(`/company/${companyId}/pstnnumber`)
}

export default PstnNumber
